import {
  Button,
  Center,
  Flex,
  Loader,
  Paper,
  Text,
  useMantineTheme,
} from "@mantine/core";
import React, { FC } from "react";
import { MessageValues } from "../hooks/useMessages";
import { ChatSessionValues } from "../hooks/useChatSessions";

interface ChatHeaderProps {
  messageValues: MessageValues;
  chatSessionValues: ChatSessionValues;
}

const ChatHeader: FC<ChatHeaderProps> = ({
  messageValues,
  chatSessionValues,
}) => {
  const theme = useMantineTheme();

  return (
    <>
      {messageValues.pageTotal < messageValues.pageNum && (
        <Paper
          bg={theme.colors.gray[5]}
          radius="xl"
          shadow="sm"
          p="xs"
          style={{ alignSelf: "center" }}
        >
          <Text c="white">This is the beginning of the chat.</Text>
        </Paper>
      )}

      {messageValues.pageNum <= messageValues.pageTotal &&
        chatSessionValues.activeSession && (
          <Button onClick={() => messageValues.getMessages(false)}>
            Get older messages
          </Button>
        )}

      {chatSessionValues.activeSession == null && (
        // Show if no session is selected
        <Flex justify="center" align="center" h="75vh">
          <Text>Select a chat session to begin</Text>
        </Flex>
      )}

      {messageValues.messagesLoading && messageValues.messages.length !== 0 && (
        // Show loader if messages are loading
        <Center>
          <Loader />
        </Center>
      )}
    </>
  );
};

export default ChatHeader;
